import { createFileRoute, Outlet } from "@tanstack/react-router";

/** What was sent: the SMS log, and one person's messages. */
export const Route = createFileRoute("/_app/growth/messages")({
  component: Outlet,
});
